import { Schema, z } from 'zod';

export enum AppearanceType {
  Toggle = 'TOGGLE',
  Dropdown = 'DROPDOWN'
}

export type Appearance = {
  type: 'TOGGLE' | 'DROPDOWN';
  helpText: string;
};

export const AppearanceSchema: Schema<Appearance> = z.object({
  type: z.nativeEnum(AppearanceType),
  helpText: z.string()
});
